import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import Slider from '../components/Slider';

const SocialMedia = () => {
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Social Media</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Social Media
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={['SocialMedia', 'Instagram', 'YouTube']}
              currentClassName="active">
              <li><a href="#SocialMedia">Social Media</a></li>
              <li><a href="#Instagram">Instagram</a></li>
              <li><a href="#YouTube">YouTube</a></li>
            </Scrollspy>
            
          </div>

        </div>
        <div className="main_lab_style">
          <section id="SocialMedia">
            
          <h1>
              Use of social media: Instagram and YouTube
          </h1>
          
          <p>
              According to Chai-lee (2013), social media applications highly benefit the process of education, as social media enables students to easily learn, collaborate, share, and interact with each other. Keeping this finding and the global occurrence of social media in mind, we decided to utilize Instagram and YouTube to educate and reach out to the general public.
          </p>

          </section>
          <section id="Instagram">
          <h1>
               Instagram
          </h1>
          <p>
              We set up an Instagram account, <a href="https://www.instagram.com/igem_cityu/?hl=en">@igem_cityu</a>, with tags such as <a href="https://www.instagram.com/explore/tags/igem/?hl=en">#igem</a>, <a href="https://www.instagram.com/explore/tags/igem2022/?hl=en">#igem2022</a>, <a href="https://www.instagram.com/explore/tags/cityu/?hl=en">#cityu</a>, <a href="https://www.instagram.com/explore/tags/secure/?hl=en">#secure</a>, <a href="https://www.instagram.com/explore/tags/synbio/?hl=en">#synbio</a>, to promote our contents. We have gathered hundreds of followers from different backgrounds that enjoy our educational materials and also managed to reach to different iGEM Teams from around the world.
          </p>
          <p>
              On this Instagram account, we introduce our team and its members, stories about interesting updates from our lab and outreach activities, our team’s public opinion survey, and our self-developed SeCure serial comics.

          </p>
          <p>
              Our Instagram stories mostly focus on glimpses of our lab and outreach activities. We post the conditions of our fungi in the lab, clips of our team meetings, and the HKUST symposium. We also made specific highlights for each of the aforementioned topics so that people can still access our stories at any time in a convenient way.

          </p>
          <p>
              The public opinion survey is promoted through our Instagram and put in our Instagram profile to ensure that more people have access to the survey and get to give their valuable opinions on our project.

          </p>
          <p>
              We regularly update educational materials in the forms of colourful serial comics, the SeCure comic. Our educational materials encompass the introduction on the iGEM competition, synthetic biology, and our research. We used comics in order to raise the interest of the general public and make the materials easier to understand.

          </p>

            <Slider images={["https://static.igem.wiki/teams/4154/wiki/social1.png", "https://static.igem.wiki/teams/4154/wiki/social2.png", "https://static.igem.wiki/teams/4154/wiki/social3.png","https://static.igem.wiki/teams/4154/wiki/social4.png"]} />

            <br />
            <br />

          </section>
          <section id="YouTube">
            <h1> YouTube</h1>
          <p>
              We uploaded a few videos on <a href="https://youtu.be/zRVBJuOI8mc">our YouTube channel</a> , CityU iGEM, in part of our Education and Science Communication activities. We hope that through using YouTube as a media of communication, more people around the world can gain access to information about synthetic biology and will become more interested about the subject and its applications.

            <br />
              In order to realize our aspiration, we uploaded the <a href="https://youtu.be/zRVBJuOI8mc"> CityU iGEM Promotional Video 2022 </a> and <a href="https://youtu.be/YeL8s4tyjv4"> the CityU Symposium Vlog 2022 </a> to our channel.

            <br />
              The Promotional Video is primarily intended to introduce our iGEM research project and its relations to people’s daily life to the general public,.

            <br />
              The Symposium Vlog is uploaded with the main objective to further publicize the iGEM competition and raise the public’s interest to iGEM.
            <br />
              The Symposium Vlog was made during the Hong Kong iGEM Symposium hosted by The Hong Kong University of Science and Technology. The vlog documented the fun and educational experience we had gained while participating in the Symposium. We interviewed members from other Hong Kong iGEM teams to listen about their opinions on the iGEM competition. We also included some clips in the vlog showing the projects of other teams, in order to educate and piqued the general public’s interest of synthetic biology’s applications.

          </p>

          </section>
        </div>
      </section>
    </div>
  );
}

export default SocialMedia;
